























import { Vue, Component } from "vue-property-decorator";
import WebinarForm from "@/components/webinars/WebinarForm.vue";
import api from "@/getinfo-api";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { BBBWebinar as IBBBWebinar } from "@/api/models/bbbwebinar";
import { ThirdPartyWebinar as IThirdPartyWebinar } from "@/api/models/third-party-webinar";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, WebinarForm }
})
export default class WebinarEdit extends Vue {
  iBBBWebinar!: IBBBWebinar;
  thirdPartyWebinar!: IThirdPartyWebinar;
  webinar!: IWebinar;
  data() {
    return {
      iBBBWebinar: undefined,
      thirdPartyWebinar: undefined,
      webinar: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "webinars" },
        label: this.$tc(this.$translate.Webinars)
      },
      {
        to: { name: "webinars" },
        label: this.webinar.title
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  getBBBWebinar() {
    api.BBBWebinarApi.get(this.$route.params.webinarId)
      .then((res: { data: IBBBWebinar }) => {
        res.data ? (this.iBBBWebinar = res.data) : undefined;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  getThirdPartyWebinar() {
    api.ThirdPartyWebinarApi.get(this.$route.params.webinarId).then(
      (res: { data: IThirdPartyWebinar }) => {
        res.data ? (this.thirdPartyWebinar = res.data) : undefined;
      }
    );
  }

  mounted() {
    api.WebinarApi.get(this.$route.params.webinarId)
      .then((res: { data: IWebinar }) => {
        this.webinar = res.data;
        document.title += ` ${res.data.title}`;
        if (this.webinar.type === "bbb") {
          this.getBBBWebinar();
        } else {
          this.getThirdPartyWebinar();
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
